import { attr } from '@ember-data/model';
import ShModel from './sh-model';

const PROFILE_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  BUSINESS: 'BUSINESS',
};

const PROFILE_TYPE_NAMES = {
  [PROFILE_TYPES.INDIVIDUAL]: 'Individual',
  [PROFILE_TYPES.BUSINESS]: 'Business',
};

const BUSINESS_TYPES = {
  CORPORATION: 'CORPORATION',
  PRIVATE_COMPANY: 'PRIVATE_COMPANY',
  PARTNERSHIP: 'PARTNERSHIP',
  NOT_FOR_PROFIT_ORGANIZATION: 'NOT_FOR_PROFIT_ORGANIZATION',
  GOVERNMENT_ENTITY: 'GOVERNMENT_ENTITY',
  PUBLIC_COMPANY: 'PUBLIC_COMPANY',
};

const BUSINESS_TYPE_NAMES = {
  [BUSINESS_TYPES.CORPORATION]: 'Corporation',
  [BUSINESS_TYPES.PRIVATE_COMPANY]: 'Private company',
  [BUSINESS_TYPES.PARTNERSHIP]: 'Partnership',
  [BUSINESS_TYPES.NOT_FOR_PROFIT_ORGANIZATION]: 'Not-for-profit organization',
  [BUSINESS_TYPES.GOVERNMENT_ENTITY]: 'Government entity',
  [BUSINESS_TYPES.PUBLIC_COMPANY]: 'Public company',
};

const VERIFICATION_STATUSES = {
  UNVERIFIED: 'unverified',
  PENDING: 'pending',
  VERIFIED: 'verified',
};

export const HYPERWALLET_USER = {
  BUSINESS_TYPES,
  BUSINESS_TYPE_NAMES,
  PROFILE_TYPES,
  PROFILE_TYPE_NAMES,
  VERIFICATION_STATUSES,
};

const HyperwalletUser = ShModel.extend({
  token: attr('string'),
  status: attr('string'),
  verificationStatus: attr('string'),
  createdOn: attr('string'),
  clientUserId: attr('string'),
  profileType: attr('string'),
  businessName: attr('string'),
  businessType: attr('string'),
  firstName: attr('string'),
  lastName: attr('string'),
  dateOfBirth: attr('string'),
  email: attr('string'),
  addressLine1: attr('string'),
  addressLine2: attr('string'),
  city: attr('string'),
  stateProvince: attr('string'),
  country: attr('string'),
  postalCode: attr('string'),
  language: attr('string'),
  programToken: attr('string'),
  authToken: attr('string'),
});

export default HyperwalletUser;
